import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import {
  deleteUser,
  getCompanySignUpCode,
  getCompanyUsers,
  setCompanyUsersLoading,
  setUserCountry,
  setUserDivision,
  toggleUserStatus,
} from '../../store/UserManagementActions'
import { getCompanySignUpCodes, getCompanyUsersList, getCompanyUsersLoading } from '../../store/UserManagementSelectors'
import {
  companyCountriesSelector,
  companyDivisionsSelector,
  managedCompaniesSelector,
} from '../../../Settings/store/SettingsSelectors'
import { getUserCompanyCountries, getCompanyDivisions } from '../../../Settings/store/SettingsActions'
import UserAdmin, { IUserAdminDispatchProps } from './UserAdmin'

const mapStateToProps = (state: IGlobalState) => ({
  companyUsers: getCompanyUsersList(state),
  usersLoading: getCompanyUsersLoading(state),
  divisions: companyDivisionsSelector(state),
  countries: companyCountriesSelector(state),
  managedCompanies: managedCompaniesSelector(state),
  signUpCodes: getCompanySignUpCodes(state),
})

const mapDispatchToProps: IUserAdminDispatchProps = {
  deleteUser,
  getCompanyUsers,
  getUserCompanyCountries,
  getCompanyDivisions,
  toggleUserStatus,
  setUserCountry,
  setUserDivision,
  getCompanySignUpCode,
  setCompanyUsersLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdmin)
